import axios from 'axios';

import { ROOT, SIGN_IN, FORGOT_PASSWORD, RESET_PASSWORD } from '../config/routes';

const PUBLIC_PAGES = [ROOT, SIGN_IN, FORGOT_PASSWORD, RESET_PASSWORD];
const PUBLIC_REQUESTS = ['/auth/sign-in', '/auth/forgot-password', '/auth/reset-password'];

let redirecting = false;

/**
 * When the API rejects the stored login (it expired, or the server's signing secret changed),
 * clear it and send the user back to sign in, instead of leaving them on pages that stay empty.
 */
export const registerSessionExpiryHandler = () => {
	axios.interceptors.response.use(
		response => response,
		error => {
			const url = error.config?.url ?? '';
			const isPublicRequest = PUBLIC_REQUESTS.some(path => url.includes(path));

			if (error.response?.status === 401 && !isPublicRequest) {
				window.localStorage.removeItem('user');
				if (!redirecting && !PUBLIC_PAGES.includes(window.location.pathname)) {
					redirecting = true;
					window.location.assign(`${SIGN_IN}?session=expired`);
				}
			}

			return Promise.reject(error);
		}
	);
};
